<template>
<div class="row plain-element">
    <div v-if="!isLoggedIn()"  class="dashboard-cards">
        <NoPermissionComponent/>
    </div>
   <div v-if="getUsername() && getSitePlanData()" class="dashboard">
    <div class="row row-cards">
      <div class="row text-start row-back">
        <a class="back-link" @click="hasHistory() ? $router.go(-1): $router.push('/')">
          <span class="material-icons chevron-left">chevron_left</span> Back To Plan
        </a>
      </div>
    </div>
    <div class="card card-details">
      <p class="error"  v-if="getFormError()">

      </p>
      <p class="error"  v-else>
      </p>
      <DeleteSitePlanComponent
              :id = id
              :current_name = getSitePlanData().name
      />
    </div>
  </div>
</div>
</template>


<script>

import { mapGetters, mapActions } from "vuex";
import { hasHistory } from "@/common/general.js";
import DeleteSitePlanComponent from "@/components/site_plans/DeleteSitePlanComponent.vue";
import NoPermissionComponent from "@/components/NoPermissionComponent.vue"

export default {
  name: "SitePlanDelete",
  components: {
    DeleteSitePlanComponent,
    NoPermissionComponent,
  },
  props: {
    id: { type: Number, required: true },
  },
  data() {
    return {

    }
  },
  methods: {
    ...mapGetters(["getSitePlanData","getFormError", "getUsername", "isLoggedIn"]),
    ...mapActions(["fetchSitePlanData", "performSetFormError"]),
    hasHistory: hasHistory,
    getPlanDetails() {
      this.fetchSitePlanData({"id": this.id })
    },
  },

  created() {
    this.getPlanDetails();
    this.performSetFormError(null);
    document.title = "Delete Site Plan";
    window.scrollTo(0,0);
  },
  beforeRouteUpdate (to, from, next) {
    this.getPlanDetails();
    next();
  }
}


</script>
